import script from "./CompanyDisabled.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDisabled.vue?vue&type=script&setup=true&lang=js"

import "./CompanyDisabled.vue?vue&type=style&index=0&id=42ef502f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ef502f"]])

export default __exports__